/**
 * @fileoverview Zod schemas for the manual ad spend import API (preview, commit, coverage, errors).
 * @module features/ad-spends/schemas/adSpendImportSchema
 */

import { z } from 'zod'
import { platformSchema } from './adSpendsSchema'

const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

export const metaImportPreviewSchema = z.object({
  platform: platformSchema,
  currency: z.string().length(3),
  dateFrom: isoDateSchema,
  dateTo: isoDateSchema,
  totalSpend: z.number(),
  // Any ISO country Meta reports, not only the dashboard's filter list.
  byCountry: z.array(z.object({ country: z.string(), amount: z.number() })),
  matchedAmount: z.number(),
  generalAmount: z.number(),
  unmatchedAmount: z.number(),
  unmatched: z.array(z.object({ productId: z.string(), title: z.string().nullable(), amount: z.number() })),
  existingDaysReplaced: z.number().int().nonnegative(),
  rowsToWrite: z.number().int().nonnegative(),
})
export type MetaImportPreview = z.infer<typeof metaImportPreviewSchema>

export const metaImportResultSchema = z.object({
  dateFrom: isoDateSchema,
  dateTo: isoDateSchema,
  rowsDeleted: z.number().int().nonnegative(),
  rowsInserted: z.number().int().nonnegative(),
  totalSpend: z.number(),
  unmatchedProductCount: z.number().int().nonnegative(),
})
export type MetaImportResult = z.infer<typeof metaImportResultSchema>

export const importCoverageSchema = z.object({
  platform: platformSchema,
  lastDate: isoDateSchema.nullable(),
})
export type ImportCoverage = z.infer<typeof importCoverageSchema>

/** Body of a 400/422 from the import endpoints (GlobalExceptionHandler ErrorResponse). */
export const importErrorBodySchema = z.object({
  message: z.string(),
  code: z.string().nullish(),
  details: z.object({ details: z.array(z.string()) }).nullish(),
})
